// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as UnconfirmedPaymentAction } from '../duck';
import UnconfirmedPayment from '../components/UnconfirmedPayment';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    isDeletingOrder: state.order.purchase.unconfirmedPayment.isDeletingOrder,
    deleteSuccess: state.order.purchase.unconfirmedPayment.deleteSuccess,
    deleteOrderError: state.order.purchase.unconfirmedPayment.deleteOrderError,
    order: state.order.order,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(UnconfirmedPaymentAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UnconfirmedPayment);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/unconfirmed-payment/container/UnconfirmedPaymentContainer.js